const deepGet = (obj: object, path: string): any => {
  const keys = path.split('.')

  const result = keys.reduce((acc, key): any => {
    const descriptor = Object.getOwnPropertyDescriptor(acc, key)
    return descriptor?.value
  }, obj)

  return result
}

export default deepGet
